import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

export function ContentHeader({
  children,
  ...props
}: PropsWithChildren<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>) {
  return (
    <div
      {...props}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'center',
        fontSize: '1.2em',
        fontWeight: 600,
        paddingBottom: '10px',
        ...props.style,
      }}>
      {children}
    </div>
  );
}
